import { extractLevel } from '@/shared/common/utils/level.util';
import type { CompanyUserOption } from '../types/createAdditionalAccount.type';
import type {
  AssignedCompanyUserOption,
  CompanyUserResponse,
} from '../types/companyUsers.type';

/**
 * Traduce una fila de `GET company/b2b/teams/users` al `CompanyUserOption` de la UI.
 * `name` puede venir `null` (usuarios `PENDING`); en ese caso se usa el `email`
 * para que la fila nunca quede en blanco. `levelDescription` puede venir `null`
 * o sin dígitos (`"Externo con tarjeta"`); ambos casos caen a nivel `0`.
 */
export function getCompanyUserAdapter(user: CompanyUserResponse): CompanyUserOption {
  return {
    id: String(user.userId),
    name: user.name ?? user.email,
    level: extractLevel(user.levelDescription) ?? 0,
  };
}

/**
 * Igual que `getCompanyUserAdapter` más la fecha de asignación a la cuenta,
 * que se conserva tal como llega (sin zona). Ausente y `null` colapsan a `null`.
 */
export function getAssignedCompanyUserAdapter(
  user: CompanyUserResponse
): AssignedCompanyUserOption {
  return {
    ...getCompanyUserAdapter(user),
    assignedAt: user.assignedAt ?? null,
  };
}
